import React from 'react';
export function WhySection() {
  return <section className="bg-ivory px-3 py-4 sm:px-6" data-id="element-166" data-mp="h56iq6gptrl6">
      <div className="mx-auto max-w-2xl space-y-2.5" data-id="element-167" data-mp="13uqcxu0f2nkp">
        <article className="rounded-md border border-navy/15 border-l-[5px] border-l-clinical bg-white p-3 shadow-sm" data-id="element-168" data-mp="13t70kehvswo7">
          <h2 className="font-heading text-[1rem] font-bold uppercase leading-tight text-navy sm:text-[1.5rem]" data-id="element-169" data-mp="1dl2z1qnvqosy">
            What if your clinical lab references were already ready?
          </h2>
          <p className="mt-1 text-[0.8rem] leading-[1.35] text-muted sm:text-[0.95rem]" data-id="element-170" data-mp="1mlrd2ld9wp5u">
            You already know how important laboratory correlation is. The
            problem is having to constantly connect CBC findings, chemistry
            results, morphology, urinalysis, microbiology and immunology
            patterns. What exactly am I looking at? What findings should I
            connect? What should I compare with another result? Instead of
            relying on scattered references and isolated values,{' '}
            <span className="font-semibold text-clinical" data-id="element-171" data-mp="2ifwqnisi21xv">
              CLINICAL LAB VISUAL ATLAS™
            </span>{' '}
            gives you visual resources covering 6 essential areas of laboratory
            pattern recognition.
          </p>
          <p className="mt-1 font-body text-[0.72rem] font-bold uppercase tracking-wide text-clinical sm:text-sm" data-id="element-172" data-mp="28nqz2a65tmj7">
            Observe. Compare. Connect. Recognize.
          </p>
        </article>

        <article className="rounded-md border border-burgundy/25 border-l-[5px] border-l-burgundy bg-white p-3 shadow-sm" data-id="element-173" data-mp="31ceqknhi5857">
          <h2 className="font-heading text-[1rem] font-bold uppercase leading-tight text-burgundy sm:text-[1.5rem]" data-id="element-174" data-mp="2sdkoihlejpk9">
            😩 Stop studying every laboratory pattern from scratch
          </h2>
          <p className="mt-1 text-[0.8rem] leading-[1.35] text-muted sm:text-[0.95rem]" data-id="element-175" data-mp="1gye6db8vmd2z">
            Your time should be spent recognizing patterns — not searching
            through disconnected values and references every day. CLINICAL LAB
            VISUAL ATLAS™ brings everything together. Hematology • Clinical
            Chemistry • Microbiology • Immunology • Urinalysis • Blood Bank
            Everything is organized so you can find the right reference, review
            it and understand the laboratory pattern.
          </p>
          <p className="mt-1 font-body text-[0.72rem] font-bold uppercase tracking-wide text-burgundy sm:text-sm" data-id="element-176" data-mp="18gc5pwefc2vd">
            Less searching. More visual recognition.
          </p>
        </article>

        <article className="rounded-md bg-navy p-3 text-white shadow-sm" data-id="element-177" data-mp="zhqrgdfzja0e">
          <h2 className="font-heading text-[1rem] font-bold uppercase leading-tight sm:text-[1.5rem]" data-id="element-178" data-mp="ksub7t3ryqop">
            ⏱️ Less searching. More ready-to-use visual references.
          </h2>
          <p className="mt-1 text-[0.8rem] leading-[1.35] text-white/90 sm:text-[0.95rem]" data-id="element-179" data-mp="brmlhzfbqy68">
            Need a hematology pattern reference? It’s ready. Need a chemistry
            correlation? It’s ready. Microbiology, immunology, urinalysis or
            blood bank patterns? They’re organized too.
          </p>
          <p className="mt-1 font-body text-[0.72rem] font-bold uppercase tracking-wide text-gold sm:text-sm" data-id="element-180" data-mp="3obs6xfzamk7u">
            Open the system. Choose the atlas. Study the pattern.
          </p>
        </article>
      </div>
    </section>;
}